import type { SessionCreated } from '@sincronia/shared';

/**
 * Sessão local para reconexão.
 *
 * O token fica apenas no armazenamento do navegador: nunca vai para a URL nem
 * é transmitido a outros clientes.
 */
export type StoredSession = SessionCreated & { name: string; savedAt: number };

const PREFIX = 'sincronia.session.';
const NAME_KEY = 'sincronia.lastName';

function key(code: string): string {
  return `${PREFIX}${code.toUpperCase()}`;
}

export function saveSession(session: SessionCreated, name: string): void {
  try {
    const value: StoredSession = { ...session, name, savedAt: Date.now() };
    window.localStorage.setItem(key(session.code), JSON.stringify(value));
    window.localStorage.setItem(NAME_KEY, name);
  } catch {
    // Armazenamento indisponível (modo privado): seguimos sem reconexão.
  }
}

export function loadSession(code: string): StoredSession | null {
  try {
    const raw = window.localStorage.getItem(key(code));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredSession>;
    if (!parsed.code || !parsed.playerId || !parsed.sessionToken) return null;
    return {
      code: parsed.code,
      playerId: parsed.playerId,
      sessionToken: parsed.sessionToken,
      name: parsed.name ?? '',
      savedAt: parsed.savedAt ?? 0,
    };
  } catch {
    return null;
  }
}

export function clearSession(code: string): void {
  try {
    window.localStorage.removeItem(key(code));
  } catch {
    // ignorado
  }
}

export function lastUsedName(): string {
  try {
    return window.localStorage.getItem(NAME_KEY) ?? '';
  } catch {
    return '';
  }
}
